import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import countUp from './lib/countUp.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';
pageLoading();



  /***********************************************************************
   * オープニングアニメーション（初回訪問時のみ）
   ***********************************************************************/
const initOpeningAnimation = () => {
  const opening = document.querySelector('.opening_animation');
  const content = document.querySelector('.opening_content');
  const mask = document.querySelector('.loading_mask');
  const hasVisited = sessionStorage.getItem('hasVisited');

  // 要素がない場合はMVタイトルのみ実行
  if (!opening || !content || !mask) {
    initHomeMvTitleAnimation();
    return;
  }

  // 2回目以降の訪問時はオープニングをスキップ
  if (hasVisited) {
    opening.style.display = 'none';
    mask.style.display = 'none';
    initHomeMvTitleAnimation();
    return;
  }

  // 初回訪問時のみオープニング実行
  opening.classList.add('is-active');

  // ロゴ表示
  setTimeout(() => {
    content.classList.add('is-show');
  }, 300);

  // ワイプ開始
  setTimeout(() => {
    mask.classList.add('is-wipe');
  }, 1550);

  // opening押し出し
  setTimeout(() => {
    opening.classList.add('is-exit');
  }, 1550);

  // maskとopeningを完全に消してからタイトル発火
  setTimeout(() => {
    opening.style.display = 'none';
    mask.style.display = 'none';

    opening.classList.remove('is-active', 'is-exit');
    content.classList.remove('is-show');
    mask.classList.remove('is-wipe');

    // 訪問済みフラグを保存
    sessionStorage.setItem('hasVisited', 'true');

    // MVタイトルアニメーション発火
    initHomeMvTitleAnimation();

  }, 2350);
};

/***********************************************************************
 * MVタイトル文字アニメーション
 ***********************************************************************/
const initHomeMvTitleAnimation = () => {
  const titleElement = document.querySelector('.home_mv_ttl');
  if (!titleElement) return;

  // 既に分割済みの場合はスキップ
  if (titleElement.dataset.split === 'true') {
    titleElement.classList.add('is-animating');
    return;
  }

  // span要素内のテキストを取得して分割
  const spans = titleElement.querySelectorAll('span');
  const fragment = document.createDocumentFragment();
  
  let charIndex = 0;

  spans.forEach((span, spanIdx) => {
    const text = span.textContent;
    const newSpan = document.createElement('span');
    
    // 各文字をwrapperのspanで囲む
    Array.from(text).forEach((char) => {
      const charSpan = document.createElement('span');
      charSpan.className = 'home_mv_char';
      charSpan.style.setProperty('--char-index', charIndex);
      charSpan.textContent = char;
      newSpan.appendChild(charSpan);
      charIndex++;
    });

    fragment.appendChild(newSpan);
    
    // 元のspanの間に<br>があった場合は再現
    if (spanIdx < spans.length - 1) {
      const br = document.createElement('br');
      fragment.appendChild(br);
    }
  });

  // 元のコンテンツをクリアして新しいコンテンツを挿入
  titleElement.innerHTML = '';
  titleElement.appendChild(fragment);
  titleElement.dataset.split = 'true';

  // アニメーション開始
  requestAnimationFrame(() => {
    titleElement.classList.add('is-animating');
  });
};

window.addEventListener('load', initOpeningAnimation);




/***********************************************************************
  　お問い合わせ関連
***********************************************************************/
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});



/***********************************************************************
　humberger menu
***********************************************************************/
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');

  // メニューを閉じる関数
  const closeMenu = () => {

    // パネル自体も同時に左へスライド
    navWrap.classList.add('hide-panel');
    setTimeout(() => {
      navWrap.classList.remove('is_open', 'hide-panel');
    }, 500); // CSSトランジション時間に合わせる

    navEle.classList.remove('is_open');
  };

  // ハンバーガーメニュークリック
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');


      navEle.classList.add('is_open');
    } else {
      // 閉じるとき
      closeMenu();
    }
  });

  // グローバルナビ内のリンクとボタンをクリックした時にメニューを閉じる（970px以下の時のみ）
  const navLinks = navWrap.querySelectorAll('a, button');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      // 画面幅970px以下の場合のみメニューを閉じる
      if (window.innerWidth <= 970 && navWrap.classList.contains('is_open')) {
        closeMenu();
      }
    });
  });
});


/***********************************************************************
　  ヘッダー スクロールで背景の高さ変更
***********************************************************************/
window.addEventListener('load', () => {
  const header = document.querySelector('.header');
  const mainimg = document.querySelector('.mainimg');

  if (!header || !mainimg) return;

  const handleScroll = () => {
    // 画面幅が769px以上の場合のみ処理
    if (window.innerWidth >= 769) {
      const mainimgBottom = mainimg.offsetTop + mainimg.offsetHeight;
      const scrollPosition = window.scrollY + header.offsetHeight;

      if (scrollPosition >= mainimgBottom) {
        header.classList.add('is_scrolled');
      } else {
        header.classList.remove('is_scrolled');
      }
    } else {
      // 769px未満の場合はクラスを削除
      header.classList.remove('is_scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  handleScroll(); // 初期実行
});




/***********************************************************************
  スクロールフェードイン
***********************************************************************/
document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.fade_up,.fade_left');
  if (!fadeElements.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is_show');
          obs.unobserve(entry.target); // 一度だけ
        }
      });
    },
    {
      root: null,        // viewport
      rootMargin: '0px 0px -15% 0px',
      threshold: 0
    }
  );

  fadeElements.forEach(el => observer.observe(el));
});


/***********************************************************************
  WORKFLOW スケジュールライン
***********************************************************************/
document.addEventListener('DOMContentLoaded', () => {
  const scheduleList = document.querySelector('.workflow_schedule_list');
  if (!scheduleList) return;

  let ticking = false;
  let isCompleted = false;

  const updateLine = () => {
    if (isCompleted) return;
    const rect = scheduleList.getBoundingClientRect();
    const start = window.scrollY + rect.top;
    const end = start + rect.height;
    const trigger = window.scrollY + window.innerHeight * 0.6;
    const progress = (trigger - start) / (end - start);
    const clamped = Math.min(1, Math.max(0, progress));
    scheduleList.style.setProperty('--line-progress', clamped.toString());
    if (clamped >= 1) {
      isCompleted = true;
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateLine);
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateLine();
      ticking = false;
    });
  };

  updateLine();
  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', updateLine);
});








/***********************************************************************
  HOME ABOUT セクション スクロールロック＆アニメーション
***********************************************************************/
window.addEventListener('load', () => {

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('#jobs');
  const items   = gsap.utils.toArray('.home_about_item');
  const nav     = document.querySelector('.home_about_nav');
  const dots    = document.querySelectorAll('.home_about_nav li');

  if (!section || items.length === 0) return;

  splitHomeAboutTitles();
  initHomeAboutTitleObserver();

  // 768px以下はGSAPを使わず通常スクロールにする
  if (window.matchMedia('(max-width: 768px)').matches) {
    items.forEach(item => {
      item.style.opacity = '1';
      item.style.visibility = 'visible';
      item.style.transform = 'none';
      item.style.pointerEvents = 'auto';
      item.classList.add('is-active');
    });
    if (nav) nav.classList.remove('is-show');
    return;
  }

  // 初期状態
  gsap.set(items, { autoAlpha: 0, y: 40, scale: 0.98 });
  gsap.set(items[0], { autoAlpha: 1, y: 0, scale: 1 });
  items[0].classList.add('is-active');
  dots[0]?.classList.add('is-active');
  revealHomeAboutTitle(items[0].querySelector('.home_about_ttl'));

  let currentIndex = 0;
  let scrollLockTimer = null;

  // ================================
  // ★ ロック用関数の固定化（固まる原因の修正）
  // ================================
  const preventScroll = (e) => {
    if (e.cancelable) e.preventDefault();
  };
  const preventKeyScroll = (e) => {
    const keys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
    if (keys.includes(e.key)) e.preventDefault();
  };

  const lockScroll = (durationMs) => {
    // 一旦イベントを消してから貼り直す（二重登録防止）
    window.removeEventListener('wheel', preventScroll);
    window.removeEventListener('touchmove', preventScroll);
    window.removeEventListener('keydown', preventKeyScroll);

    window.addEventListener('wheel', preventScroll, { passive: false });
    window.addEventListener('touchmove', preventScroll, { passive: false });
    window.addEventListener('keydown', preventKeyScroll, { passive: false });

    if (scrollLockTimer) clearTimeout(scrollLockTimer);
    
    scrollLockTimer = setTimeout(() => {
      window.removeEventListener('wheel', preventScroll);
      window.removeEventListener('touchmove', preventScroll);
      window.removeEventListener('keydown', preventKeyScroll);
    }, durationMs);
  };

  /* =========================
    表示切り替え関数
  ========================= */
  function showItem(index) {
    if (index === currentIndex) return;

    const prev = items[currentIndex];
    const next = items[index];
    const prevTitle = prev.querySelector('.home_about_ttl');
    const nextTitle = next.querySelector('.home_about_ttl');

    prev.classList.remove('is-active');
    next.classList.add('is-active');

    if (prevTitle) prevTitle.classList.remove('is-revealed');
    revealHomeAboutTitle(nextTitle);

    gsap.to(prev, {
      autoAlpha: 0, y: -40, scale: 0.96, duration: 0.7, ease: 'power2.out', overwrite: 'auto'
    });

    gsap.fromTo(next,
      { autoAlpha: 0, y: 40, scale: 0.96 },
      { autoAlpha: 1, y: 0, scale: 1, duration: 0.9, ease: 'power2.out', overwrite: 'auto' }
    );

    dots.forEach(d => d.classList.remove('is-active'));
    dots[index]?.classList.add('is-active');

    currentIndex = index;
  }

  /* =========================
    ScrollTrigger
  ========================= */
  ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: () => `+=${(items.length + 1) * 80}%`, // ★ここを少し長くすると余裕が出ます
    pin: true,
    pinSpacing: true,
    scrub: 1,
    anticipatePin: 1,
    invalidateOnRefresh: true,

    onEnter: () => nav.classList.add('is-show'),
    onLeave: () => nav.classList.remove('is-show'),
    onEnterBack: () => nav.classList.add('is-show'),
    onLeaveBack: () => nav.classList.remove('is-show'),

    onUpdate(self) {
      const progress = self.progress;
      
      // 最初と最後に遊びを作る
      let activeProgress = gsap.utils.mapRange(0.1, 0.9, 0, 1, progress);
      activeProgress = gsap.utils.clamp(0, 1, activeProgress);
      
      const index = Math.round(activeProgress * (items.length - 1));
      
      if (index !== currentIndex) {
        showItem(index);
        if (!ScrollTrigger.isTouch) {
          lockScroll(1000);
        }
      }
    }
  });

  /* =========================
    右ナビクリック
  ========================= */
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      const st = ScrollTrigger.getAll().find(s => s.trigger === section);
      if (!st) return;

      const targetProgress = gsap.utils.mapRange(0, 1, 0.1, 0.9, i / (items.length - 1));
      
      gsap.to(window, {
        scrollTo: st.start + targetProgress * (st.end - st.start),
        duration: 1,
        ease: "power2.inOut"
      });
    });
  });
});

/***********************************************************************
  HOME ABOUT タイトル文字分割＆アニメーション
***********************************************************************/
const splitTextToChars = (element) => {
  if (!element || element.dataset.split === 'true') return;
  const text = element.textContent || '';
  element.textContent = '';
  Array.from(text).forEach((char, index) => {
    const span = document.createElement('span');
    span.className = 'char';
    span.style.setProperty('--char-index', index);
    span.textContent = char === ' ' ? '\u00A0' : char;
    element.appendChild(span);
  });
  element.dataset.split = 'true';
};

const splitHomeAboutTitles = () => {
  const titleParts = document.querySelectorAll('.home_about_ttl .cmn_ttl_en, .home_about_ttl .cmn_ttl_ja');
  titleParts.forEach(splitTextToChars);
};

const revealHomeAboutTitle = (title) => {
  if (!title) return;
  title.classList.add('is-revealed');
};

const initHomeAboutTitleObserver = () => {
  if (!window.matchMedia('(max-width: 768px)').matches) return;
  const titles = document.querySelectorAll('.home_about_ttl');
  if (!titles.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -15% 0px',
      threshold: 0
    }
  );

  titles.forEach(title => observer.observe(title));
};

document.addEventListener('DOMContentLoaded', () => {
  // オープニングアニメーション初期化
  initOpeningAnimation();

  modalImage();
  // カウントアップアニメーション初期化
  countUp('.culture_data_list_number', {
    duration: 800,
    threshold: 0.5,
  });

  // Home Jobs Image Slideshow
  // initHomeJobsSlideshow();

  // Home Jobs Section Scroll Lock
  // initHomeJobsScrollLock();
});



/***********************************************************************
  リスト　アニメーション
***********************************************************************/
const initCmnListAnimation = () => {
  // すべての #cmn_list に対応
  const cmnLists = document.querySelectorAll('#cmn_list');
  if (!cmnLists.length) return;

  // IntersectionObserverで画面内に入ったときにアニメーション開始
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const listItems = entry.target.querySelectorAll('li');
          listItems.forEach((item, index) => {
            const delay = (index + 1) * 0.2;
            item.style.animationDelay = `${delay}s`;
          });
          entry.target.classList.add('is-animated');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -15% 0px',
      threshold: 0
    }
  );

  cmnLists.forEach(list => observer.observe(list));
};

window.addEventListener('load', () => {
  initCmnListAnimation();
});


/***********************************************************************
  画像スライドショー
***********************************************************************/
const initImageSlideshow = () => {
  const slideshowContainers = document.querySelectorAll('[data-slideshow]');
  if (!slideshowContainers.length) return;

  slideshowContainers.forEach(container => {
    const images = container.querySelectorAll('.slide-image');
    if (images.length <= 1) return;

    let currentIndex = 0;

    setInterval(() => {
      images[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].classList.add('is-active');
    }, 3000);
  });
};

window.addEventListener('load', () => {
  initImageSlideshow();
});